module.exports = __webpack_public_path__ + "img/email.6aca26ac.png";